<template>
  <div id="app">
    <Navigation/>
    <section class="section main-section">
      <router-view/>
    </section>
    <Footer/>
  </div>
</template>

<script>
  import Navigation from './components/Navigation'
  import Footer from './components/Footer'

  export default {
    name: 'app',
    components: {
      'Navigation': Navigation,
      'Footer': Footer
    }
  }
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap');

#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: 18px;
}

html, body {
  height: 100%;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.section {
  flex: 1;
}

.main-section {
  padding-bottom: 5px !important;
}

</style>
